export default function HomeSchemaOrg() {
  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '博彩网',
        url: 'https://bo-cai-wang.com',
        description: '专业博彩平台导航与资讯中心，提供最新博彩网站评测、优惠活动、赔率分析及安全指南。',
        foundingDate: '2014',
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'customer support',
          availableLanguage: ['Chinese'],
        },
      },
      {
        '@type': 'WebSite',
        name: '博彩网',
        url: 'https://bo-cai-wang.com',
        inLanguage: 'zh-CN',
        description: '专业博彩平台导航与资讯中心',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://bo-cai-wang.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: '博彩网 - 专业博彩平台导航与资讯中心',
        url: 'https://bo-cai-wang.com',
        description: '博彩网是您最值得信赖的专业博彩资讯平台，提供最新博彩网站评测、优惠活动、赔率分析及安全指南。',
        isPartOf: { '@id': 'https://bo-cai-wang.com/#website' },
        about: { '@id': 'https://bo-cai-wang.com/#organization' },
        inLanguage: 'zh-CN',
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '如何判断一个博彩平台是否正规可靠？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '判断平台是否正规可以从以下几个方面入手：查看平台是否持有合法的博彩牌照（如菲律宾PAGCOR、马耳他MGA等），了解平台的运营历史和口碑评价，检查网站是否使用SSL加密，客服响应是否及时专业，以及提现是否顺畅。',
            },
          },
          {
            '@type': 'Question',
            name: '新手应该如何选择适合自己的博彩平台？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '新手选择平台时建议优先考虑以下因素：平台的正规性和安全性、新用户优惠力度、游戏种类的丰富程度、充值提现的便捷性、中文客服支持质量等。',
            },
          },
          {
            '@type': 'Question',
            name: '在线博彩充值提现安全吗？有哪些支付方式？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '正规博彩平台都会采用银行级别的加密技术保障交易安全。主流支付方式包括银行转账、第三方支付、加密货币等。',
            },
          },
          {
            '@type': 'Question',
            name: '博彩平台的红利和优惠活动有哪些注意事项？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '参与优惠活动时需特别注意以下几点：仔细阅读活动规则和条款，了解流水倍数要求，注意活动的有效期限，确认是否有游戏限制，以及是否存在最高提现金额限制。',
            },
          },
          {
            '@type': 'Question',
            name: '博彩网的文章评测是否客观公正？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '博彩网始终坚持客观、公正、专业的评测原则。我们的评测团队由资深博彩行业分析师组成，评测过程基于真实体验和多维度数据对比。',
            },
          },
        ],
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首页',
            item: 'https://bo-cai-wang.com',
          },
        ],
      },
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema, null, 2) }}
    />
  );
}